<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Task name</label>
          <b-form-input
              type="text"
              :state="informationValidation.isTaskNameProvided"
              v-model="updatedPersonalTaskDetails.taskName"></b-form-input>

          <b-form-invalid-feedback v-if="!informationValidation.isTaskNameProvided">
            This field must not be empty.
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">To-do list name</label>
          <b-form-input
              type="text"
              v-model="updatedPersonalTaskDetails.toDoListName"
              disabled></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Priority</label>
          <b-form-select v-model="updatedPersonalTaskDetails.priority" :options="priorityOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Description</label>
          <b-form-input
              type="text"
              v-model="updatedPersonalTaskDetails.description"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Due date</label>
          <b-form-datepicker
              v-model="updatedPersonalTaskDetails.dueDate"></b-form-datepicker>
          <b-button v-if="updatedPersonalTaskDetails.dueDate" variant="outline-danger" @click="removeDueDate"
                    id="removeDueDateButton">
            Remove due date
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Location</label>
          <b-form-input
              type="text"
              v-model="updatedPersonalTaskDetails.location"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Reminder</label>
          <b-form-datepicker
              v-model="reminderDateSelected"
              disabled></b-form-datepicker>
          <b-form-text>The task reminder can only be configured from the mobile application.</b-form-text>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label>at</label>
          <b-form-timepicker
              type="date"
              v-model="reminderTimeSelected"
              disabled></b-form-timepicker>
          <b-form-text>The task reminder can only be configured from the mobile application.</b-form-text>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Attachment</label>
          <br>
          <input type="file" accept="image/*" @change="onFileChange" id="attachment-input"/>
          <b-button v-if="updatedPersonalTaskDetails.attachmentUrl" variant="outline-danger" @click="removeAttachment"
                    id="removeAttachmentButton">
            Remove attachment
          </b-button>
          <div id="preview">
            <img v-if="updatedPersonalTaskDetails.attachmentUrl" :src="updatedPersonalTaskDetails.attachmentUrl"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="updatePersonalTaskDetails">Update task details</b-button>
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";

  export default {
    name: "PersonalTaskDetails.vue",
    props: {
      personalTaskDetails: Object
    },
    data() {
      return {
        updatedPersonalTaskDetails: {
          toDoListId: this.personalTaskDetails.toDoListId,
          taskId: this.personalTaskDetails.taskId,
          taskName: this.personalTaskDetails.taskName,
          toDoListName: this.personalTaskDetails.toDoListName,
          completed: this.personalTaskDetails.completed,
          priority: this.personalTaskDetails.priority,
          description: this.personalTaskDetails.description,
          dueDate: null,
          inboxTask: this.personalTaskDetails.inboxTask,
          location: this.personalTaskDetails.location,
          reminderDate: this.personalTaskDetails.reminderDate,
          reminderTime: this.personalTaskDetails.reminderTime,
          taskCreationDate: this.personalTaskDetails.taskCreationDate,
          taskCreationTime: this.personalTaskDetails.taskCreationTime,
          initialAttachmentUrl: this.personalTaskDetails.attachment,
          attachmentUrl: this.personalTaskDetails.attachment,
          attachmentFile: null,
          taskType: 'Personal Task'
        },
        reminderDateSelected: null,
        reminderTimeSelected: null,
        priorityOptions: [
          {value: 0, text: 'High'},
          {value: 1, text: 'Medium'},
          {value: 2, text: 'Low'}
        ],
        informationValidation: {
          isTaskNameProvided: null
        }
      }
    },
    validations: {
      updatedPersonalTaskDetails: {
        taskName: {
          required
        }
      }
    },
    methods: {
      onFileChange(e) {
        this.updatedPersonalTaskDetails.attachmentFile = e.target.files[0];

        if (this.updatedPersonalTaskDetails.attachmentFile !== undefined) {
          this.updatedPersonalTaskDetails.attachmentUrl = URL.createObjectURL(this.updatedPersonalTaskDetails.attachmentFile);
        } else {
          this.updatedPersonalTaskDetails.attachmentUrl = null
        }
      },
      removeAttachment() {
        this.updatedPersonalTaskDetails.attachmentUrl = null
        document.getElementById("attachment-input").value = "";
      },
      removeDueDate() {
        this.updatedPersonalTaskDetails.dueDate = null
      },
      updatePersonalTaskDetails() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.updatedPersonalTaskDetails.taskName.required) {
          this.informationValidation.isTaskNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isTaskNameProvided = true
        }

        if (isValid) {
          this.$store.dispatch('updatePersonalTask', this.updatedPersonalTaskDetails)
          this.hideModal('task-details-modal')
        }
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    mounted() {
      // convert the format of the task due date
      if (this.personalTaskDetails.dueDate !== null) {
        const taskDueDate = new Date(this.personalTaskDetails.dueTime)
        const year = taskDueDate.getFullYear()
        const month = taskDueDate.getMonth() + 1 < 10 ? "0" + (taskDueDate.getMonth() + 1) : taskDueDate.getMonth()
        const day = taskDueDate.getDate() < 10 ? "0" + taskDueDate.getDate() : taskDueDate.getDate()

        this.updatedPersonalTaskDetails.dueDate = year + "-" + month + "-" + day
      }

      // convert the format of the reminder date
      if (this.personalTaskDetails.reminderDate !== null) {
        const reminderDueDate = new Date(this.personalTaskDetails.reminderTime)
        const year = reminderDueDate.getFullYear()
        const month = reminderDueDate.getMonth() + 1 < 10 ? "0" + (reminderDueDate.getMonth() + 1) : reminderDueDate.getMonth()
        const day = reminderDueDate.getDate() < 10 ? "0" + reminderDueDate.getDate() : reminderDueDate.getDate()
        const hour = reminderDueDate.getHours()
        const minute = reminderDueDate.getMinutes()

        this.reminderDateSelected = year + "-" + month + "-" + day
        this.reminderTimeSelected = hour + ':' + minute
      }
    }
  }
</script>

<style scoped>
  #removeDueDateButton {
    margin-top: 1em;
  }

  #removeAttachmentButton {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  #preview {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #preview img {
    max-width: 100%;
    max-height: 500px;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .secondary-input-button {
    background-color: white;
    color: #212441;
    padding: 0.5em;
  }

  .secondary-input-button:hover {
    background-color: #212441;
    color: white;
    padding: 0.5em;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
